export default class Representante {
    id: number | null;
    codigoInterno: number | null;
    ativo: boolean;
    nome: string;
    nomeFantasia: string | null;
    tipoPessoa: string;
    numeroDocumento: string;
    rg: string | null;
    orgaoEmissorRg: string | null;
    inscricaoEstadual: string | null;
    inscricaoMunicipal: string | null;
    email: string | null;
    telefone: string | null;
    logradouro: string | null;
    numeroEndereco: string | null;
    complemento: string | null;
    bairro: string | null;
    municipio: string | null;
    uf: string | null;
    cep: string | null;
    percentualComissaoPadrao: number;

    constructor(
        id: number | null = null,
        codigoInterno: number | null = null,
        ativo = true,
        nome = '',
        nomeFantasia: string | null = null,
        tipoPessoa = 'FISICA',
        numeroDocumento = '',
        rg: string | null = null,
        orgaoEmissorRg: string | null = null,
        inscricaoEstadual: string | null = null,
        inscricaoMunicipal: string | null = null,
        email: string | null = null,
        telefone: string | null = null,
        logradouro: string | null = null,
        numeroEndereco: string | null = null,
        complemento: string | null = null,
        bairro: string | null = null,
        municipio: string | null = null,
        uf: string | null = null,
        cep: string | null = null,
        percentualComissaoPadrao = 0
    ) {
        this.id = id;
        this.codigoInterno = codigoInterno;
        this.ativo = ativo;
        this.nome = nome;
        this.nomeFantasia = nomeFantasia;
        this.tipoPessoa = tipoPessoa;
        this.numeroDocumento = numeroDocumento;
        this.rg = rg;
        this.orgaoEmissorRg = orgaoEmissorRg;
        this.inscricaoEstadual = inscricaoEstadual;
        this.inscricaoMunicipal = inscricaoMunicipal;
        this.email = email;
        this.telefone = telefone;
        this.logradouro = logradouro;
        this.numeroEndereco = numeroEndereco;
        this.complemento = complemento;
        this.bairro = bairro;
        this.municipio = municipio;
        this.uf = uf;
        this.cep = cep;
        this.percentualComissaoPadrao = percentualComissaoPadrao;
    }
}
